import React from 'react';
import PropTypes from 'prop-types';
import {Icons} from '@learningblocks/exp-constants';
import className from './style.module.scss';

const {
  AlertLargeFail: AlertFail,
  AlertLargeSuccess: AlertSuccess,
  IncorrectRelative: CloseButton
} = Icons;
const FEEDBACK_SUCCESS = 'SUCCESS';

export function PredictionFeedback(props) {
  const onCloseClick = (event) => props.onClose(event);

  const isSuccesss = () => props.type === FEEDBACK_SUCCESS;

  const getWrapperClass = () =>
    `${className.feedback} ${
      isSuccesss() ? className.success : className.fail
    } ${props.className}`;

  const getFeedbackIcon = () =>
    isSuccesss() ? (
      <AlertSuccess className={className.feedback_icon} />
    ) : (
      <AlertFail className={className.feedback_icon} />
    );

  const renderCloseButton = () =>
    props.onClose ? (
      <CloseButton
        className={className.feedback_close}
        onClick={onCloseClick}
      />
    ) : null;

  if (props.type) {
    return (
      <div className={getWrapperClass()}>
        {getFeedbackIcon()}
        <p className={className.feedback_message}>{props.message}</p>
        {renderCloseButton()}
      </div>
    );
  } else return null;
}

PredictionFeedback.propTypes = {
  /**
   * ClassName to set on Component
   */
  className: PropTypes.string,
  /**
   * Type of feedback to render [ if empty string feedback won't show ]
   */
  type: PropTypes.oneOf(['SUCCESS', 'FAIL', '']),
  /**
   * Function to invoke when close button is pressed
   * [ if function not passed in close button not displayed]
   */
  onClose: PropTypes.func,
  /**
   * Feedback message to display
   */
  message: PropTypes.string,
};

PredictionFeedback.defaultProps = {
  className: '',
  message: 'Prediction Submitted!',
  onClose: null,
};
